import { AppConfig } from 'AppConfig';

const ALL_REPORT_TYPE = 'ALL';
const STANDARD_REPORT_TYPE = AppConfig.REPORT_CATEGORY.LEGACY.code;
const SAVED_CATEGORY = { code: 'saved', name: 'Saved' };

const PRIMARY_REPORT_OPTIONS = [
  { value: STANDARD_REPORT_TYPE, label: AppConfig.REPORT_CATEGORY.LEGACY.name },
  { value: AppConfig.REPORT_CATEGORY.EXPLORER.code, label: AppConfig.REPORT_CATEGORY.EXPLORER.name },
  { value: AppConfig.REPORT_CATEGORY.SMART.code, label: AppConfig.REPORT_CATEGORY.SMART.name },
  { value: AppConfig.REPORT_CATEGORY.CUSTOM.code, label: AppConfig.REPORT_CATEGORY.CUSTOM.name }
];

const MY_REPORTS_OPTIONS = [
  { value: AppConfig.REPORT_CATEGORY.AD_HOC.code, label: AppConfig.REPORT_CATEGORY.AD_HOC.name },
  { value: SAVED_CATEGORY.code, label: SAVED_CATEGORY.name },
];

const REPORT_TYPE_OPTIONS = [
  { value: ALL_REPORT_TYPE, label: 'All' },
  ...PRIMARY_REPORT_OPTIONS,
  ...(MY_REPORTS_OPTIONS.length > 0 ? [{ isDivider: true, label: 'My Reports' }] : []),
  ...MY_REPORTS_OPTIONS
];

const REPORT_TYPE_ORDER = [
  AppConfig.REPORT_CATEGORY.LEGACY.code,
  AppConfig.REPORT_CATEGORY.EXPLORER.code,
  AppConfig.REPORT_CATEGORY.SMART.code,
  AppConfig.REPORT_CATEGORY.CUSTOM.code,
  AppConfig.REPORT_CATEGORY.AD_HOC.code
];

const BASE_SORT_OPTIONS = [
  { value: 'alphabetical_asc', label: 'Alphabetical (A-Z)' },
  { value: 'most_viewed', label: 'Most Viewed' },
  { value: 'most_saved', label: 'Most Saved' },
];

const DEFAULT_SORT_OPTIONS = [...BASE_SORT_OPTIONS];

const MANAGE_SAVED_SORT_OPTIONS = [
  { value: 'recently_saved', label: 'Recently Saved' },
  ...BASE_SORT_OPTIONS
];

const SMART_CARD_SORT_DEFS = {
  recently_saved: { value: 'recently_saved', label: 'Recently Saved' },
  most_viewed: { value: 'most_viewed', label: 'Most Viewed' },
  needs_attention: { value: 'needs_attention', label: 'Needs Attention' },
  ben_insights_pick: { value: 'ben_insights_pick', label: 'BenInsights Pick' },
  newest: { value: 'newest', label: 'Newest' }
};

const SMART_CARD_SORT_OPTIONS = [
  SMART_CARD_SORT_DEFS.recently_saved,
  SMART_CARD_SORT_DEFS.most_viewed,
  SMART_CARD_SORT_DEFS.needs_attention,
  SMART_CARD_SORT_DEFS.newest
];

const REPORT_SMART_CARD_SORT_OPTIONS = [
  SMART_CARD_SORT_DEFS.most_viewed,
  SMART_CARD_SORT_DEFS.needs_attention,
  SMART_CARD_SORT_DEFS.newest
];
// hide SMART_CARD_SORT_DEFS.ben_insights_pick 

const SORT_OPTIONS_MAP = {
  [ALL_REPORT_TYPE]: MANAGE_SAVED_SORT_OPTIONS,
  [AppConfig.REPORT_CATEGORY.SMART.code]: SMART_CARD_SORT_OPTIONS,
};

const REPORT_TYPE_ALIASES = {
  AD_HOC: 'adhoc',
  'Ad Hoc': 'adhoc',
  adhoc: 'adhoc',
  standard: 'standard',
  legacy: 'standard',
  LEGACY: 'standard',
  explorer: 'explorer',
  EXPLORER: 'explorer',
  exclusive: 'custom',
  smart: 'smart',
  SMART: 'smart',
  saved: 'saved',
  custom: 'custom',
  CUSTOM: 'custom',
  favorite: 'saved'
};

export { ALL_REPORT_TYPE, STANDARD_REPORT_TYPE, PRIMARY_REPORT_OPTIONS, MY_REPORTS_OPTIONS, REPORT_TYPE_OPTIONS, DEFAULT_SORT_OPTIONS, SMART_CARD_SORT_OPTIONS, SORT_OPTIONS_MAP, REPORT_TYPE_ALIASES, REPORT_TYPE_ORDER, MANAGE_SAVED_SORT_OPTIONS, REPORT_SMART_CARD_SORT_OPTIONS };
